import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'

import { EuiButton, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiTitle } from '@elastic/eui'

import { AcImage } from 'api/interfaces'
import { useGetBusinessTypeQuery } from 'api/rtkQueryApi/platform/businessTypesApi'
import { RootState } from 'app/rootReducer'
import { resetSearchImage } from 'components/chooseImage/searchImageSlice'
import InternetSuggestedAds from 'components/suggestedAds/InternetSuggestedAds'
import { clearSuggestions as clearGeneralSuggestions, fetchImages as fetchGeneralImages, fetchSuggestions as fetchGeneralSuggestions } from 'components/suggestedAds/generalSuggestionSlice'
import history from 'services/HistoryService'

import { BuilderStyle, setAd, setBuilderStyle, setBusinessType, setImage, setSuggest } from './builderInternetRetailSlice'

const SuggestionsStep: React.FC = () => {
  const dispatch = useDispatch()
  const builder = useSelector((state: RootState) => state.builderInternetRetail)
  const { currentAccount, isShopifyUser } = useSelector((state: RootState) => state.app)
  const [companyName, setCompanyName] = useState(builder.suggest?.companyName ?? '')
  const chosenBusinessTypeResponse = useGetBusinessTypeQuery({ id: currentAccount?.businessTypeId ?? '' }, { skip: !!builder.businessType || !currentAccount?.businessTypeId })

  useEffect(() => {
    if (!builder.businessType && chosenBusinessTypeResponse.data) {
      dispatch(setBusinessType(chosenBusinessTypeResponse.data))
    }
  }, [chosenBusinessTypeResponse.data])

  useEffect(() => {
    if (!builder.suggest) {
      dispatch(
        setSuggest({
          companyName: currentAccount?.name ?? '',
          cityName: currentAccount?.city ?? ''
        })
      )
    }
  }, [currentAccount])

  const proceedWithSuggestion = (image: AcImage, headline: string, body: string) => {
    const ad = {
      id: '',
      headline: headline,
      body: body,
      companyName: currentAccount!.name,
      callToAction: 'Learn More',
      destinationUrl: currentAccount!.website || ''
    }
    dispatch(setImage(image))
    dispatch(setAd(ad))
    history.push('/build/internet/public/create')
  }

  useEffect(() => {
    if (currentAccount && builder.businessType && builder.suggest) {
      dispatch(clearGeneralSuggestions())
      dispatch(fetchGeneralSuggestions(currentAccount.id, builder.businessType.id, builder.suggest.companyName, builder.suggest.cityName))
      dispatch(fetchGeneralImages(builder.businessType.id))
      setCompanyName(builder.suggest!.companyName)
    }
  }, [dispatch, currentAccount, builder.businessType, builder.suggest])

  const gotoSuggest = () => {
    history.push('/build/internet/public/suggest')
  }

  const gotoStart = () => {
    history.push('/build/internet/public/start')
  }

  const gotoCreate = () => {
    dispatch(resetSearchImage())
    dispatch(
      setAd({
        id: '',
        headline: '',
        body: '',
        companyName: currentAccount?.name || '',
        callToAction: 'Learn More',
        destinationUrl: currentAccount?.website || ''
      })
    )
    dispatch(setBuilderStyle(BuilderStyle.Build))
    history.push('/build/internet/public/create')
  }

  const content = (() => {
    let c

    if (currentAccount && builder.businessType && builder.suggest) {
      c = <InternetSuggestedAds businessTypeId={builder.businessType.id} proceed={proceedWithSuggestion} companyName={companyName} />
    }

    return c ?? <React.Fragment />
  })()

  const onBackClick = () => {
    if (isShopifyUser) {
      gotoStart()
    } else {
      gotoSuggest()
    }
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>Suggested Ads</title>
      </Helmet>
      <EuiFlexGroup responsive={false}>
        <EuiFlexItem>
          <EuiTitle size='s'>
            <h3>Suggested Ads</h3>
          </EuiTitle>
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiButton onClick={gotoCreate} fullWidth={false}>
            Switch to Ad Builder
          </EuiButton>
        </EuiFlexItem>
      </EuiFlexGroup>
      <EuiSpacer />
      {content}
      <EuiButton id='back' fill type='button' color='text' onClick={onBackClick} iconType='arrowLeft' iconSide='left'>
        Back
      </EuiButton>
    </React.Fragment>
  )
}

export default SuggestionsStep
